export default function authenticate(username,password){        
    return fetch(window.sessionStorage.getItem("apiPath")+'/api/users/login',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: username,
                        password: password,
                    })
                }
            ).then((response) => response.json());    
    
}


// WEBPACK FOOTER //
// ./src/services/authentication.js